export default {
  methods: {
    leadShortAddress(town, postcode, url = null) {
      const displayTown = (url !== null && url.search('london/') !== -1) ? 'London' : town;
      return [displayTown, postcode].filter(Boolean).join(', ');
    },
    leadShortAddressHtml(town, postcode, url = null) {
      const displayTown = (url !== null && url.search('london/') !== -1) ? 'London' : town;
      const formattedPostcode = (town && town.length > 2) ? '<br/>' + postcode : postcode;
      return [displayTown, formattedPostcode].filter(Boolean).join(', ');
    },
    leadFullAddress(town, postcode, address1, address2) {
      return [address1, address2, town, postcode].filter(Boolean).join(', ');
    }
  }
}
